import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, defineMessages } from 'react-intl';
import { ActionablePlaceholder } from 'ui-components/components/display-grid/actionable-placeholder';
import { SharedMessagesPropType } from '../../../../prop-types/intl';

const messages = defineMessages({
  title: {
    description: 'ordersShippedPlaceholder.title',
    defaultMessage: 'You have no <b>Shipped</b> orders',
    id: '3gD699',
  },
  titleWithStore: {
    description: 'ordersShippedPlaceholder.titleWithStore',
    defaultMessage: 'You have no <b>Shipped</b> orders from {storeName}',
    id: 'U7w5Wi',
  },
  description: {
    description: 'ordersShippedPlaceholder.description',
    defaultMessage: 'This section shows all the orders you have already shipped. You can create return labels or re-ship orders as needed.',
    id: 'R3QEpK',
  },
});

const title = (storeName) =>
  storeName ? (
    <FormattedMessage {...messages.titleWithStore} values={{ b: (chunks) => <b>{chunks}</b>, storeName }} />
  ) : (
    <FormattedMessage {...messages.title} values={{ b: (chunks) => <b>{chunks}</b> }} />
  );

const OrdersShippedPlaceholder = ({ action, sharedMessages, hasStoreConnected, storeName }) => {
  return (
    <ActionablePlaceholder
      action={action}
      actionDescription={!hasStoreConnected && <FormattedMessage {...sharedMessages.actionDescription} />}
      buttonContent={!hasStoreConnected && <FormattedMessage {...sharedMessages.buttonContent} />}
      description={<FormattedMessage {...messages.description} />}
      title={title(storeName)}
    />
  );
};

OrdersShippedPlaceholder.propTypes = {
  action: PropTypes.func.isRequired,
  sharedMessages: SharedMessagesPropType.isRequired,
  hasStoreConnected: PropTypes.bool.isRequired,
  storeName: PropTypes.string,
};

export default OrdersShippedPlaceholder;
